<template>
  <div :class="{'hideleft':hide === true}" class="page">
    <div class="crumb-container">
      <ol class="breadcrumb">
        <li>
          <a href="javascript:;" class="crumb-home z-font-size-14">备案</a>
        </li>
        <li>
          <a href="javascript:;" class="z-font-size-14">快递材料</a>
        </li>
      </ol>
    </div>
    <div class="page-main z-padding-h-20-precent">
      <div class="panel-heading">
        <div v-show="activeNames === 'index'" class="panel-title z-padding-right-10-precent">快递材料</div>
        <div v-show="activeNames === 'list'" class="panel-title z-padding-right-10-precent">购买（备案幕布/核验单）</div>
        <div v-show="activeNames === 'share'" class="panel-title z-padding-right-10-precent">幕布分享</div>
        <el-button v-show="activeNames === 'index'" size="small" type="primary" @click="activeNames = 'list'">购买幕布</el-button>
        <el-button v-show="activeNames === 'list'" size="small" type="info" @click="activeNames = 'index'">快递列表</el-button>
        <el-button v-show="activeNames === 'share'" size="small" type="info" @click="activeNames = 'index'">返回</el-button>
        <!--<span v-if="activeNames === 'index'" class="z-color-red z-display-inlineBlock z-margin-left-15-precent">由于快递公司放假，快递停止揽件备案幕布1月26日邮递最后一批次，后续的需要等节后快递公司上班后邮递</span>-->
      </div>
      <div class="panel-body clearfix">
        <!--列表-->
        <el-table v-show="activeNames === 'index'" :data="userList" v-loading="listLoading" highlight-current-row show-header style="width: 100%;">
          <el-table-column prop="id" label="快递公司/单号" align="center">
          </el-table-column>
          <el-table-column prop="name" label="收件人" align="center">
          </el-table-column>
          <el-table-column prop="address" label="收件地址" min-width="200" align="center">
          </el-table-column>
          <el-table-column prop="tel" label="联系电话" align="center">
          </el-table-column>
          <el-table-column prop="state" label="快递状态" align="center">
          </el-table-column>
          <el-table-column prop="time" label="更新时间" align="center">
          </el-table-column>
          <el-table-column prop="" label="幕布分享" align="center">
            <template slot-scope="scope">
              <span class="z-curPonit z-color-a" @click="activeNames = 'share'">[分享]</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination v-show="activeNames === 'index'" background layout="total, sizes" :page-sizes="[10, 20, 30, 50]" @size-change="handleSizeChange" :page-size="10" :total="total" class="pull-left">
        </el-pagination>
        <el-pagination v-show="activeNames === 'index'" background layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="count" :total="total">
        </el-pagination>

        <div v-show="activeNames === 'list'">
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" :label-position="labelPosition" label-width="200px" class="beian-ruleForm">
            <el-form-item label="所在地区：">
              <xkuaidi-city :province="cityInfo['province']" :city="cityInfo['city']" :area="cityInfo['area']" :DISTRICTS="DISTRICTS" v-model="cityInfo"></xkuaidi-city>
            </el-form-item>
            <el-form-item label="详细地址：" prop="address" :show-message="!formFocus.address">
              <el-input v-model="ruleForm.address" placeholder="建议您如实填写详细收货地址，例如街道名称，门牌号码，楼层和房间号等信息" @focus="formFocus.address = true" @blur="formFocus.address = false"></el-input>
              <div class="icp-tip" v-show="formFocus.address">
                <i class="iconfont icon-i z-absolute"></i>
                <div class="icp-msg">
                  <em class="hoticon-left"></em>
                  请填入正确的详细地址，2至50个字符！
                </div>
              </div>
            </el-form-item>
            <el-form-item label="收货人姓名：" prop="name" :show-message="!formFocus.name">
              <el-input v-model="ruleForm.name" placeholder="请输入您的收货人姓名，在1至45个字符之内" @focus="formFocus.name = true" @blur="formFocus.name = false"></el-input>
              <div class="icp-tip" v-show="formFocus.name">
                <i class="iconfont icon-i z-absolute"></i>
                <div class="icp-msg">
                  <em class="hoticon-left"></em>
                  请输入您的收货人姓名，在1至45个字符之内！
                </div>
              </div>
            </el-form-item>
            <el-form-item label="联系方式：" prop="tel" :show-message="!formFocus.tel">
              <el-input v-model="ruleForm.tel" placeholder="请输入您的手机号码或者固话" @focus="formFocus.tel = true" @blur="formFocus.tel = false"></el-input>
              <div class="icp-tip" v-show="formFocus.tel">
                <i class="iconfont icon-i z-absolute"></i>
                <div class="icp-msg">
                  <em class="hoticon-left"></em>
                  请输入您的手机号码或者固话！
                </div>
              </div>
            </el-form-item>
            <el-form-item label="备注：" prop="remark">
              <el-input type="textarea" v-model="ruleForm.remark" @focus="formFocus.remark = true" @blur="formFocus.remark = false"></el-input>
              <div class="icp-tip" v-show="formFocus.remark">
                <i class="iconfont icon-i z-absolute"></i>
                <div class="icp-msg">
                  <em class="hoticon-left"></em>
                  如需其他帮助请留言，三丰云备案中心将竭诚为您服务~
                </div>
              </div>
            </el-form-item>
          </el-form>
          <div class="ub-box z-padding-top-20-precent z-padding-bottom-70-precent">
            <div class="ub-box z-padding-left-60-precent">
              <img src="../../assets/imgs/mb1.jpg" alt="">
            </div>
            <div class="z-padding-left-30-precent">
              <p class="z-font-size-20 z-font-weight-700 z-color-333">三丰云ICP备案专用幕布</p>
              <div class="ub-box z-margin-top-19-precent">
                <div class="z-margin-top-20-precent z-font-size-16 z-color-999">价&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;格</div>
                <div class="z-margin-left-20-precent z-margin-top-2-precent gff8">
                  <span class="z-font-size-20">¥</span>
                  <span class="z-font-size-37">{{usemoney}}</span>
                </div>
              </div>
              <div class="ub-box z-margin-top-19-precent">
                <div class="z-font-size-16 z-color-999">商品详情</div>
                <div class="z-margin-left-20-precent">
                  <p class="z-font-size-16 z-color-333">三丰云ICP备案专用幕布&nbsp;&nbsp;x&nbsp;1</p>
                  <p>
                    <span class="z-font-size-16 z-color-333">赠：网站真实性核验单&nbsp;&nbsp;x&nbsp;2</span>
                  </p>
                </div>
              </div>
              <div class="ub-box z-margin-top-19-precent">
                <div class="z-margin-top-20-precent z-font-size-16 z-color-999">账户余额</div>
                <div class="z-margin-left-20-precent z-margin-top-2-precent gff8">
                  <span class="z-font-size-20">¥</span>
                  <span class="z-font-size-37">{{money}}</span>
                </div>
              </div>
              <div class="ub-box z-margin-top-10-precent">
                <div class="z-font-size-16 z-margin-top-10-precent z-color-999">使用优惠券</div>
                <div class="z-margin-left-20-precent z-margin-top-5-precent">
                  <el-select v-model="pay.coupon" placeholder="--请选择--" style="width: 450px">
                    <el-option
                      v-for="item in pay.yhq"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
              </div>
              <div class="ub-box z-margin-top-20-precent z-display-inlineBlock z-lineHeight-20">
                <xbutton font="立即购买" type="orange" @XbuttonService="submitForm('ruleForm')"/>
              </div>
            </div>
          </div>
        </div>

        <div v-show="activeNames === 'share'">
          <el-form :model="shareForm" :rules="share" ref="shareForm" :label-position="labelPosition" label-width="200px" class="beian-ruleForm">
            <el-form-item label="所在地区：">
              <xkuaidi-city :province="scityInfo['province']" :city="scityInfo['city']" :area="scityInfo['area']" :DISTRICTS="DISTRICTS" v-model="scityInfo"></xkuaidi-city>
            </el-form-item>
            <el-form-item label="详细地址：" prop="address">
              <el-input v-model="shareForm.address" placeholder="请详细填写通讯地址,以便通过审核"></el-input>
            </el-form-item>
            <el-form-item label="单位名称：" prop="company">
              <el-input v-model="shareForm.company" placeholder="请填写单位名称"></el-input>
            </el-form-item>
            <el-form-item label="工作时间：" prop="time">
              <el-input v-model="shareForm.time" placeholder="请填写工作时间,如:周一至周五  8:30—18:00"></el-input>
            </el-form-item>
            <el-form-item label="联系人：" prop="linkman">
              <el-input v-model="shareForm.linkman" placeholder="请填写联系人姓名"></el-input>
            </el-form-item>
            <el-form-item label="手机号：" prop="tel">
              <el-input v-model="shareForm.tel" placeholder="请填写真实的手机号,以便获取手机验证码"></el-input>
            </el-form-item>
            <el-form-item label="现场图片：" prop="pic">
              <div class="ub-box">
                <div class="ub-box">
                  <div class="col-img">
                    <label for="fileImg1" class="z-curPonit">
                      <img v-show="!showimg" src="../../assets/imgs/img3.png" alt="请上传现场图片" width="135" height="102">
                    </label>
                    <label for="fileImg1" class="z-curPonit">
                      <img v-show="showimg" :src="dataUrl" width="135" height="102"/>
                    </label>
                  </div>
                </div>
                <div class="z-margin-left-15-precent">
                  <p class="gff8 z-font-size-14">JPG或PNG格式</p>
                  <p class="z-font-size-12 z-color-999 z-padding-bottom-5-precent">请上传备案点现场图片,以便审核通过</p>
                  <label for="fileImg1" class="choose-file">选择文件</label>
                  <input type="file" id="fileImg1" name="CertImg" @change="handleFileChange" ref="inputer" class="z-width-30-precent" style="visibility: hidden;">
                </div>
              </div>
            </el-form-item>
            <el-form-item label="备注：" prop="remark">
              <el-input type="textarea" v-model="shareForm.remark" placeholder="如需要填写备注,则不能超过255个字符"></el-input>
            </el-form-item>
            <el-form-item label="验证码：" prop="code" style="width: 980px" class="captcha">
              <el-input v-model="shareForm.code" style="width: 132px"></el-input>
              <img :src="captcha"  title="点击更换" class="error-img" @click="changeYzm">
            </el-form-item>
            <el-form-item label="手机验证码：" prop="telcode" style="width: 980px" class="captcha">
              <el-input v-model="shareForm.telcode" style="width: 132px;vertical-align: middle;"></el-input>
              <el-button size="small" type="primary" @click="checkCode('shareForm')">获取手机验证码</el-button>
            </el-form-item>
            <el-form-item label="" prop="" class="captcha">
              <el-button size="small" type="primary" @click="submitShare('shareForm')">提交申请</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import XkuaidiCity from 'components/commons/XkuaidiCity.vue'
  import Xbutton from 'components/commons/Xbutton.vue'
  import beianService from 'business/beianService.js'
  import userService from 'business/userService.js'
  import {mapGetters,mapActions} from 'vuex'
  export default {
    data() {
      return {
        userList: [],
        count:10,
        total:0,
        page:1,
        listLoading:false,
        labelPosition:'right',
        activeNames:'index',
        showimg:false,
        DISTRICTS:[],
        cityInfo: {
          province:'中国',
          city:'北京',
          area:'北京市'
        },
        cityId:{
          provinceid: 0,
          cityid: 1,
          districtid: 0
        },
        ruleForm: {
          address:'',
          name:'',
          tel:'',
          remark:'',
        },
        scityInfo: {
          province:'中国',
          city:'北京',
          area:'北京市'
        },
        scityId:{
          provinceid: 0,
          cityid: 1,
          districtid: 0
        },
        shareForm: {
          address:'',
          compony:'',
          time:'',
          name:'',
          tel:'',
          remark:'',
          code:'',
          telcode:'',
        },
        rules: {
          address: [
            { required: true, message: '请填入正确的详细地址，2至50个字符！', trigger: 'blur' },
          ],
          linkman: [
            { required: true, message: '请输入您的收货人姓名，在1至45个字符之内！', trigger: 'blur' }
          ],
          tel: [
            { required: true, message: '联系方式不能为空！', trigger: 'blur' }
          ],
        },
        share: {
          address: [
            { required: true, message: '详细地址不能为空', trigger: 'blur' }
          ],
          time: [
            { required: true, message: '工作时间不能为空', trigger: 'blur' }
          ],
          linkman: [
            { required: true, message: '联系人不能为空', trigger: 'blur' }
          ],
          tel: [
            { required: true, message: '手机号不能为空', trigger: 'blur' }
          ],
          code: [
            { required: true, message: '请输入验证码！', trigger: 'blur' },
            { validator: async function (rule, value, callback) {
                let data = 'cmd=check_yzm'+'&yzm='+value
                let {vueData, state} = await beianService.transformToVue('beianKuaidi','POST',data)
                if(vueData.response == 200){
                  callback()
                }else{
                  callback(new Error(vueData.msg))
                }
              },trigger: 'blur'}
          ]

        },
        formFocus: {
          address: false,
          name:false,
          tel:false,
          remark:false,
        },
        pay:{
          coupon:'',
          yhq:[],
        },
        usemoney:'',
        money:'',
        dataUrl:'',
        captcha:'https://api.sanfengyun.com/www/yzm.php?rnd='+Math.random()
      }
    },
    components:{
      Xbutton,
      XkuaidiCity
    },
    props:{
      hide:Boolean,
    },
    mounted() {
      this.kuaidiInfo()
      this.getArea()
      this.couponInfo()
      this.kuaidiMoney()
    },
    methods:{
      ...mapActions(['SETTHREE_MENU']),
      async submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.submit()
          } else {
            return false;
          }
        });
      },
      async checkCode(formName) {
        this.$refs[formName].validateField('tel',(valid) => {
          if (!valid) {
            this.$refs[formName].validateField('code',(valid) => {
              if (!valid) {
                this.sendCode()
              } else {
                return false;
              }
            });
          } else {
            return false;
          }
        });
      },
      async submitShare(formName) {
        this.$refs[formName].validateField('address',(valid) => {
          if (!valid) {
            this.$refs[formName].validateField('time',(valid) => {
              if (!valid) {
                this.$refs[formName].validateField('linkman',(valid) => {
                  if (!valid) {
                    this.$refs[formName].validateField('tel',(valid) => {
                      if (!valid) {
                        this.set_fenxiang()
                      } else {
                        return false;
                      }
                    });
                  } else {
                    return false;
                  }
                });
              } else {
                return false;
              }
            });
          } else {
            return false;
          }
        });
      },
      async kuaidiInfo() {
        this.listLoading = true
        let data = 'cmd=kuaidi_list'+'&count='+ this.count +'&page='+ this.page
        let {vueData, state} = await beianService.transformToVue('beianKuaidi','POST',data)
        if(vueData.response == 200 ) {
          this.total = vueData.msg.allcount
          this.userList = vueData.msg.content.map((item, index) => {
            if(item.kd_com === null){
              item.kd_com = ''
            }
            if(item.kd_hao === null){
              item.kd_hao = ''
            }else{
              item.kd_hao = '(' + item.kd_hao + ')'
            }
            return {
              id:item.kd_com + item.kd_hao ,
              name:item.kd_name,
              address:item.kd_addr,
              tel:item.kd_tel,
              state:item.kd_state,
              time:item.lasttime
            }
          })
          this.listLoading = false
        }else {
          this.$toast(vueData.msg,'fail')
        }
      },
      async kuaidiMoney() {
        let {vueData, state} = await beianService.transformToVue('beianInfo','POST','cmd=beian_money')
        if(vueData.response == 200 ) {
          this.usemoney = vueData.price
        }else {
          this.$toast(vueData.msg,'fail')
        }
      },
      async getArea() {
        let {vueData, state} = await userService.transformToVue('userInfo','POST','cmd=area_dic')
        if(state.code === '000' ) {
          this.DISTRICTS = vueData
        }else {
          this.$toast('请刷新页面...','fail')
        }
      },
      async couponInfo() {
        let {vueData, state} = await userService.transformToVue('userInfo','POST','cmd=userinfo')
        if(state.code === '000' ) {
          this.money = vueData.msg.money
          let onuse = vueData.msg.yhq.onuse.map((item, index) => {
            return {
              value: item.yhq_id,
              label: item.yhq_id+'(可优惠'+ item.money_all +'元，最低消费满'+ item.money_need +'元可使用)',
              yhq_use: item.yhq_use
            }
          })
          this.pay.yhq = onuse.filter(items => {
            return items.yhq_use === '备案' || items.yhq_use === '通用'
          })
          this.pay.yhq.unshift({
            value: '',
            label: '不使用优惠券',
            yhq_use: ''
          })
        }else {
          this.$toast('请刷新页面','fail')
        }
      },
      async submit() {
        for(let i in this.DISTRICTS){
          if(this.DISTRICTS[i].area_title == this.cityInfo.province){
            this.cityId.provinceid = Number(this.DISTRICTS[i].area_id)
            let province = this.DISTRICTS[i].province
            for(let j in province){
              if(province[j].area_title == this.cityInfo.city){
                this.cityId.cityid=Number(province[j].area_id)
                let city = province[j].city
                for(let k in city){
                  if(city[k].area_title == this.cityInfo.area){
                    this.cityId.districtid=Number(city[k].area_id)
                  }
                }
              }
            }
          }
        }
        let data = 'cmd=kuaidi_set'+
          '&provinceid='+ this.cityId.cityid +
          '&cityid=' + this.cityId.districtid +
          '&kd_addr=' + this.ruleForm.address +
          '&kd_tel=' + this.ruleForm.tel +
          '&kd_name=' + this.ruleForm.name +
          '&yhq_id=' + this.pay.coupon +
          '&remark=' + this.ruleForm.remark
        let {vueData, state} = await beianService.transformToVue('beianKuaidi','POST',data)
        if(vueData.response == 200 ) {
          this.$toast(vueData.msg,'success')
          this.kuaidiInfo()
          this.activeNames = false
        }else {
          this.$toast(vueData.msg,'fail')
        }
      },
      changeYzm() {
        this.captcha = 'https://api.sanfengyun.com/www/yzm.php?rnd='+Math.random()
      },
      imgPreview (file) {
        let self = this;
        // 看支持不支持FileReader
        if (!file || !window.FileReader) return;

        if (/^image/.test(file.type)) {
          // 创建一个reader
          var reader = new FileReader();
          // 将图片将转成 base64 格式
          reader.readAsDataURL(file);
          // 读取成功后的回调
          reader.onloadend = function () {
            self.dataUrl = this.result;
          }
        }
        this.showimg = true
      },
      handleFileChange () {
        let inputDOM = this.$refs.inputer;
        // 通过DOM取文件数据
        this.file  = inputDOM.files[0];
        // 这里就可以获取到文件的名字了
        this.fileName = this.file.name;

        this.imgPreview(this.file);
      },
      async sendCode(){
        let data = 'cmd=mobile_yzm'+
          '&mobile='+ this.shareForm.tel +
          '&img_yzm='+ this.shareForm.code
        let {vueData, state} = await beianService.transformToVue('beianKuaidi','POST',data)
        if(vueData.response == 200 ) {
          this.$toast(vueData.msg,'success')
        }else {
          this.$toast(vueData.msg,'fail')
        }
      },
      async set_fenxiang() {
        for(let i in this.DISTRICTS){
          if(this.DISTRICTS[i].area_title == this.scityInfo.province){
            this.scityId.provinceid = Number(this.DISTRICTS[i].area_id)
            let province = this.DISTRICTS[i].province
            for(let j in province){
              if(province[j].area_title == this.scityInfo.city){
                this.scityId.cityid=Number(province[j].area_id)
                let city = province[j].city
                for(let k in city){
                  if(city[k].area_title == this.scityInfo.area){
                    this.scityId.districtid=Number(city[k].area_id)
                  }
                }
              }
            }
          }
        }
        let formData = new window.FormData();
        formData.append('cmd', 'set_fenxiang')
        formData.append('province_id', this.scityId.cityid)
        formData.append('city_id', this.scityId.districtid)
        formData.append('address', this.shareForm.address)
        formData.append('c_name', this.shareForm.company)
        formData.append('work_time', this.shareForm.time)
        formData.append('linkman', this.shareForm.linkman)
        formData.append('mobile', this.shareForm.tel)
        formData.append('remark', this.shareForm.remark)
        formData.append('c_img', this.$refs.inputer.files[0])
        formData.append('mobile_yzm', this.shareForm.telcode)
        let {vueData, state} = await beianService.transformToVue('beianKuaidi','POST',formData)
        if(vueData.response == 200 ) {
          this.SETTHREE_MENU(4)
          this.$toast(vueData.msg,'success')
          this.$router.push('/beian4')
        }else {
          this.$toast(vueData.msg,'fail')
        }
      },
      handleCurrentChange(val) {
        this.page = val;
        this.kuaidiInfo()
      },
      handleSizeChange(val) {
        this.count = val
        this.kuaidiInfo()
      },
    }
  }
</script>
<style scoped>
  .hideleft { margin-left: 80px; }
  .xpagination { bottom:-4rem;right:0;transform:translateX(-50%); }
  .beian-ruleForm .el-input,.el-select,.el-textarea {
    width: 374px;
  }
  .captcha .el-form-item__error {
    left: 270px;
  }
  .icp-msg {
    color: #4074e1;
    border: solid 1px #4074e1;
    background: #ecf1fc;
    border-radius: 3px;
    position: relative;
    margin-top: 10px;
    font-size: 12px;
    line-height: 18px;
    padding: 10px;
    width: 352px;
  }
  em{
    font-style: normal;
    font-weight: 500;
  }
  .icp-tip {
    position: absolute;
    left: 375px;
    top: 0;
    margin-left: 10px;
    width: 400px;
    line-height: 32px;
    font-size: 12px;
  }
  .icp-tip .icp-msg {
    margin: 0 0 0 30px;
    padding: 6px 10px;
    width: 300px;
  }
  .icp-tip span {
    padding-left: 6px;
  }
  .hoticon-left {
    position: absolute;
    top: 12px;
    left: -4px;
    background: url(../../assets/imgs/hoticon.png) no-repeat;
    background-position: 0 -5px;
    width: 4px;
    height: 6px;
  }
  .icon-i {
    color: #4074e1;
    padding-left: 5px;
  }
  .z-margin-top-19-precent {
    margin-top: 1.9rem;
  }
  .z-margin-top-2-precent {
    margin-top: 0.2rem;
  }
  .col-img {
    border: solid 1px #bbbaba;
    width: 135px;
    height: 102px;
    border-radius: 3px;
    margin-right: 10px;
  }
  .error-img {
    width: 100px;
    height: 30px;
    vertical-align: top;
    margin-left: 10px;
    cursor: pointer;
  }
  .choose-file {
    display: inline-block;
    position: absolute;
    padding: 4px 12px;
    margin-bottom: 0;
    font-size: 13px;
    line-height: 18px;
    text-align: center;
    vertical-align: middle;
    cursor: pointer;
    color: #fff;
    border-color: #2082dd;
    background-color: #2a89e0;
    border-radius: 2px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/beian/beian3.vue